import { FieldGroup } from "@/ds/shadcn/components/ui/field";
import type { ComponentProps, FC } from "react";

export const Form: FC<ComponentProps<"form">> = props => {
	const {
		children
	} = props;

	return (
		<form {...props}>
			<FieldGroup>
				{children}
			</FieldGroup>
		</form>
	);
};
